import { render, staticRenderFns } from "./centertitle.vue?vue&type=template&id=49b1ad14&scoped=true&"
import script from "./centertitle.vue?vue&type=script&lang=js&"
export * from "./centertitle.vue?vue&type=script&lang=js&"
import style0 from "./centertitle.vue?vue&type=style&index=0&id=49b1ad14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49b1ad14",
  null
  
)

export default component.exports